// generated by genversion
export var version = '4.7.10';
//# sourceMappingURL=version.js.map